export default "__VITE_ASSET__DQrKhDPZ__"